import { Link } from "react-router-dom";
import { cn } from "../../../utils/classnames";
import { TableCalendarIcon, TableCopyIcon, TableEyeIcon, TablePencilIcon, TableTrashIcon } from "./Icons";

// The booking list's 30x30 gold square is the house style for row actions;
// everything else here is the same square in a different tone.
const buttonBase =
  "tw:flex tw:h-[30px] tw:w-[30px] tw:items-center tw:justify-center tw:rounded-[2px] tw:border-0 tw:p-0";

const TONES = {
  gold: "tw:bg-[#D4B055] tw:!text-white",
  dark: "tw:bg-[#282828] tw:!text-white",
  danger: "tw:bg-[#FDECEA] tw:!text-[#EA4335]",
  goldSoft: "tw:bg-[#F9EDD3] tw:!text-[#A3780F]",
  neutral: "tw:bg-[#F3F3F3] tw:!text-[#282828]",
};

export const AdminRowActions = ({ children }) => (
  <div className="tw:flex tw:items-center tw:justify-center tw:gap-[6px]">{children}</div>
);

export const AdminIconLink = ({ to, tone = "gold", label, children, className }) => (
  <Link to={to} className="tw:border-0 tw:bg-transparent tw:p-0" aria-label={label}>
    <span className={cn(buttonBase, TONES[tone] || TONES.gold, className)}>{children}</span>
  </Link>
);

export const AdminIconButton = ({ onClick, tone = "gold", label, disabled, children, className, ...rest }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    aria-label={label}
    className={cn(buttonBase, TONES[tone] || TONES.gold, disabled && "tw:cursor-not-allowed tw:opacity-40", className)}
    {...rest}
  >
    {children}
  </button>
);

export const ViewLink = ({ to, label = "View detail" }) => (
  <AdminIconLink to={to} tone="gold" label={label}>
    <TableEyeIcon />
  </AdminIconLink>
);

export const EditLink = ({ to, label = "Edit" }) => (
  <AdminIconLink to={to} tone="gold" label={label}>
    <TablePencilIcon />
  </AdminIconLink>
);

export const ScheduleLink = ({ to, label = "View schedule" }) => (
  <AdminIconLink to={to} tone="dark" label={label}>
    <TableCalendarIcon />
  </AdminIconLink>
);

export const DeleteButton = ({ onClick, label = "Delete", ...rest }) => (
  <AdminIconButton onClick={onClick} tone="danger" label={label} {...rest}>
    <TableTrashIcon />
  </AdminIconButton>
);

export const CopyButton = ({ onClick, label = "Copy link", ...rest }) => (
  <AdminIconButton onClick={onClick} tone="neutral" label={label} {...rest}>
    <TableCopyIcon />
  </AdminIconButton>
);

export default AdminRowActions;
